import { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router";
import axios from 'axios';

import { AppContext } from '../../../../context.js';

import Loading from '../../../components/loading.js';
import Helmet from "../../../components/helmet.js";

function PatientsSourceOverview() {
  const context = useContext(AppContext);

  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [statistics, setStatistics] = useState(null);

  useEffect(() => {
    let u = context.addSpiner();
    axios.post('/api/admin/analytics/patients/source-overview', {})
      .then((response) => {
        setStatistics(response.data);
        setLoading(false);
      })
      .catch((e) => {
        context.addError(e);
        context.removeSpiner(u);
      })
      .finally(() => {
        context.removeSpiner(u);
      });
  }, []);

  function renderPartners() {
    if (!statistics || !statistics.partners || statistics.partners.length === 0) {
      return (
        <div className="card mb-2">
          <div className="card-header sm">
            <div className="typo-normal-150">No partners available.</div>
          </div>
        </div>
      );
    }

    return statistics.partners.filter(partner => partner.total > 0).sort((a, b) => b.total - a.total).map((partner, index) => {
      let url = `/patients`;
      if (partner.selfReferral) {
        url += `?selfReferral=true`;
      } else {
        url += `?partnerID=${partner.partnerID}`;
      }

      return (
        <div key={index} className={"card-header clickable sm " + (statistics.partners.filter(p => p.total > 0).length === index + 1 ? "last" : "")} onClick={() => navigate(url)}>
          <div className="row">
            <div className="col-xs-2">
              <div className="typo-strong-150">{partner.selfReferral ? "Self Referral" : partner.partnerName}</div>
            </div>
            <div className="col-xs-10">
              <div className="row">
                <div className="col-xs-3 text-center">
                  <div className="typo-strong-150">{partner.total}</div>
                </div>
                <div className="col-xs-3 text-center">
                  <div className="typo-normal-150">{partner.created}</div>
                </div>
                <div className="col-xs-3 text-center">
                  <div className="typo-normal-150">{partner.active}</div>
                </div>
                <div className="col-xs-3 text-center">
                  <div className="typo-normal-150">{partner.archived}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });
  }

  if (loading) {
    return (
      <>
        <Helmet title="Analytics | Patient Source Overview" />
        <Loading />
      </>
    );
  }

  if (!statistics) {
    return (
      <>
        <Helmet title="Analytics | Patient Source Overview" />
        <div className="card mb-2">
          <div className="card-header sm">
            <div className="typo-normal-150">No data available.</div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Helmet title="Analytics | Patient Source Overview" />

      <div className="container">
        <div className="row mb-4">
          <div className="col-xs-12">
            <div className="d-flex justify-content-between align-items-center">
              <div className="">
                <div className="typo-hero-small">Patient Source Overview</div>
                <div className="typo-normal-175">Track patient enrollment sources and distribution across partners. Monitor referral channel performance and identify key patient acquisition sources</div>
              </div>
              <div className="w-25 text-end">
                {/* <div className="item typo-normal-150 ms-2" onClick={() => navigate('/patient/create')}><FilePlus height={16} width={16} background={'none'} fill={'grey'} /> Create Patient</div> */}
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">

            <div className="card mb-2">
              <div className="card-header sm">
                <div className="row">
                  <div className="col-xs-2">
                    <div className="typo-strong-150">Source</div>
                  </div>
                  <div className="col-xs-10">
                    <div className="row">
                      <div className="col-xs-3 text-center">
                        <div className="typo-strong-150">Total</div>
                      </div>
                      <div className="col-xs-3 text-center">
                        <div className="typo-strong-150">Created</div>
                      </div>
                      <div className="col-xs-3 text-center">
                        <div className="typo-strong-150">Active</div>
                      </div>
                      <div className="col-xs-3 text-center">
                        <div className="typo-strong-150">Archived</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="card mb-2">
              <div className="card-header sm">
                <div className="row">
                  <div className="col-xs-2">
                    <div className="typo-strong-175">All Patients</div>
                  </div>
                  <div className="col-xs-10">
                    <div className="row">
                      <div className="col-xs-3 text-center">
                        <div className="typo-strong-175">{statistics.total}</div>
                      </div>
                      <div className="col-xs-3 text-center">
                        <div className="typo-strong-175">{statistics.created}</div>
                      </div>
                      <div className="col-xs-3 text-center">
                        <div className="typo-strong-175">{statistics.active}</div>
                      </div>
                      <div className="col-xs-3 text-center">
                        <div className="typo-strong-175">{statistics.archived}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {renderPartners()}

            </div>
          </div>
        </div>
      </div>
      
    </>
  );
}

export default PatientsSourceOverview;

